import notes from "../images/notes.png";
import double from "../images/double-tick.png";
import plus from "../images/Plus.png";
import {
  useAddTodoMutation,
  useDeleteTodoMutation,
  useGetTodosQuery,
  useTodoCompleteMutation,
} from "../features/api/apiSlice";
import { useRef } from "react";

export default function Header() {
  const { data } = useGetTodosQuery();
  const [todoComplete] = useTodoCompleteMutation();
  const [addTodo, { isLoading, isSuccess }] = useAddTodoMutation();
  const [deleteTodo] = useDeleteTodoMutation();
  const inputRef = useRef(null);
  let text = "";
  const handleAll = () => {
    data.forEach((todo) => {
      const { id } = todo;
      console.log(todo);
      setTimeout(function () {
        todoComplete({ id, data: { completed: true } });
      }, 1000);
    });
  };
  const handleDeleteAll = () => {
    data.forEach((todo) => {
      const { id } = todo;
      console.log(todo);
      if (todo.completed) {
        setTimeout(function () {
          deleteTodo(id);
        }, 1000);
      }
    });
  };
  const values = (e) => {
    text = inputRef.current.value;
    console.log(text);
    addTodo({ text: text });
    inputRef.current.value = "";

    e.preventDefault();
  };
  return (
    <div>
      <form
        class="flex items-center bg-gray-100 px-2 py-2 rounded-md"
        onSubmit={values}
      >
        <img src={notes} class="w-6 h-6" alt="Add todo" />
        <input
          type="text"
          ref={inputRef}
          placeholder="Type your todo"
          class="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
        />
        <button
          disabled={isLoading}
          type="submit"
          class={`appearance-none w-8 h-8 bg-[url(${plus})] bg-no-repeat bg-contain`}
        ></button>
      </form>

      <ul class="flex justify-between my-4 text-xs text-gray-500">
        <li class="flex space-x-1 cursor-pointer" onClick={handleAll}>
          <img class="w-4 h-4" src={double} alt="Complete" />
          <span>Complete All Tasks</span>
        </li>
        <li class="cursor-pointer" onClick={handleDeleteAll}>
          Clear completed
        </li>
      </ul>
    </div>
  );
}
